export const isNewerVersion = (oldVer, newVer) => {
    return newVer.localeCompare(oldVer, undefined, { numeric: true, sensitivity: 'base' }) > 0;
};
